import React, { useState, useRef } from 'react';
import StoryContext from '../contexts/StoryContext';
import StoryQ1 from './Lead/StoryQ1';
import StoryQ2 from './Lead/StoryQ2';
import colors from '../modules/colors';
import CallToAction from './Lead/CallToAction';
import CallToActionButton from './CallToActionButton';
import PrintToPDF from './PrintToPDF';
import Resources from './Resources';

function LeadStory() {
  const [selectedState, setSelectedState] = useState(null);
  const ref = useRef(null);

  return (
    <StoryContext.Provider value={{
      selectedState,
      setSelectedState,
      primaryColor: colors.yellow,
      darkColor: colors.darkYellow,
      lightColor: colors.lightYellow,
      secondaryColor: colors.grey,
      contrastColor: colors.taupe,
      messageBackgroundColor: colors.taupe,
      selectionColor: colors.grey,
      hoverColor: colors.green,
    }}
    >
      <CallToActionButton targetRef={ref} />
      <StoryQ1 />
      <StoryQ2 />
      <div ref={ref} />
      <CallToAction />
      <PrintToPDF />
      <Resources />
    </StoryContext.Provider>
  );
}

export default LeadStory;
